import PropTypes from 'prop-types';
import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';

// Similar to PriceDisplay, used to show 'Free Shipping' or '$10 Shipping'.
// Does not render a currency code since it's meant to be used next to the
// main price (which can have a currency code).
// Expects a Entities::Money object
class ShippingPrice extends React.Component {
  isFree() {
    return this.price.amount_cents === 0;
  }

  get price() {
    return this.props.shippingRate;
  }

  render() {
    if (!this.props.shippingRate) { return false; }
    if (this.isFree()) { return <span>{I18n.t('js.listing.shipping.free')}</span>; }

    return (
      <span className="ws-nowrap">
        <Translate
          html
          text="js.listing.shipping.price"
          args={{
            price: this.price.display,
            spanOpen: '<span class="price-display">',
            spanClose: '</span>',
          }}
        />
      </span>
    );
  }
}

ShippingPrice.propTypes = {
  shippingRate: PropTypes.object,
};

export default ShippingPrice;
